import { render, staticRenderFns } from "./DynamicSlide.vue?vue&type=template&id=0fe09fa6"
import script from "./DynamicSlide.vue?vue&type=script&lang=js"
export * from "./DynamicSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports